import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Interface } from "readline";

interface UserProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
const UserdropDown: React.FC<UserProps> = (props: UserProps) => {
  const [isclicked, setIsclicked] = useState(false);
  const navigate = useNavigate();
  const handleClick = () => {
    setIsclicked((current) => !current);
  };
  function logout() {
    Cookies.remove("newJwt", { path: "/" });
    navigate("/");
  }
  return (
    <>
      <div className="navbar-collapse collapse">
        <ul className="navbar-nav ms-auto">
          <li className="nav-item dropdown ms-lg-2">
            <span
              onClick={handleClick}
              className="nav-link dropdown-toggle position-relative cursor-pointer"
              data-bs-toggle="dropdown"
            >
              <i className="align-middle fas fa-cog"></i>
            </span>
            {isclicked ? (
              <div
                className="dropdown-menu dropdown-menu-end show cursor-pointer right-0"
                style={{ right: "0px" }}
              >
                {" "}
                <span className="dropdown-item">
                  <i className="align-middle me-1 fas fa-fw fa-user"></i> View
                  Profile
                </span>
               
                <NavLink  to={"changePassword"}>
                <span className="dropdown-item">
                  <i className="align-middle me-1 fas fa-fw fa-lock"></i>
                  Change Password
                  </span>
                  </NavLink>
                
                <div className="dropdown-divider"></div>
                <span className="dropdown-item" onClick={props.onClick}>
                  <i className="align-middle me-1 fas fa-fw fa-arrow-alt-circle-right"></i>{" "}
                  Sign out
                </span>
              </div>
            ) : (
              ""
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export { UserdropDown };
